import { Link } from 'react-router-dom';
import { AuthCard } from './AuthLayout';

type LegalPage = 'terms' | 'privacy';

const content: Record<
  LegalPage,
  { title: string; subtitle: string; sections: { heading: string; body: string }[] }
> = {
  terms: {
    title: 'Terms of Service',
    subtitle: 'The basics of using tween.studio.',
    sections: [
      {
        heading: 'Using the service',
        body: 'By creating an account or using tween.studio you agree to use the product lawfully and respectfully. You are responsible for content you create and for keeping your credentials secure.',
      },
      {
        heading: 'Accounts',
        body: 'We may suspend accounts that abuse the platform, attempt unauthorized access, or violate these terms.',
      },
      {
        heading: 'Changes',
        body: 'We may update these terms as the product evolves. Continued use after changes means you accept the updated terms. This page is a living draft and will be refined as we ship.',
      },
    ],
  },
  privacy: {
    title: 'Privacy Policy',
    subtitle: 'How we handle your information.',
    sections: [
      {
        heading: 'What we collect',
        body: 'We collect account details you provide (such as name and email), authentication data, and usage needed to run the editor and keep your projects available.',
      },
      {
        heading: 'How we use it',
        body: 'Data is used to authenticate you, store projects, improve the product, and communicate service-related updates. We do not sell your personal information.',
      },
      {
        heading: 'Cookies',
        body: 'Essential cookies keep you signed in and secure the session. Optional cookies help us understand product usage. You can choose Essential only or Accept all from the cookie banner; your choice is stored locally in your browser.',
      },
      {
        heading: 'Your choices',
        body: 'You can update profile details from the app and request account deletion by contacting support. Third-party sign-in providers process data under their own policies.',
      },
    ],
  },
};

export function TermsOfService() {
  return <LegalDocument page="terms" />;
}

export function PrivacyPolicy() {
  return <LegalDocument page="privacy" />;
}

function LegalDocument({ page }: { page: LegalPage }) {
  const doc = content[page];

  return (
    <AuthCard title={doc.title} subtitle={doc.subtitle}>
      <div className="auth-legal-doc">
        {doc.sections.map((section) => (
          <section key={section.heading} className="auth-legal-section">
            <h3>{section.heading}</h3>
            <p>{section.body}</p>
          </section>
        ))}
        <div className="auth-footer">
          <Link to="/login" className="auth-link">
            Back to sign in
          </Link>
        </div>
      </div>
    </AuthCard>
  );
}
